import Stack from '@mui/material/Stack';
import { createSvgIcon } from '@mui/material/utils';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Stack": Stack, "@mui/material/utils": { createSvgIcon } } } });
export default ClientProvider;
